import React, { useState } from "react";
import PreAssessment from "../../components/PreAssessment/PreAssessment";
import ExamProctor from "../../components/ExamProctor/ExamProctor";

const TEST_IDS = {
  user_id: "test-user-001",
  user_exam_id: "test-exam-001",
  assessment_id: "test-assessment-001",
  candidate_name: "Test Candidate",
};

const ProctorTest: React.FC = () => {
  const [phase, setPhase] = useState<"pre" | "exam">("pre");
  const [flags, setFlags] = useState<string[]>([]);

  return (
    <div style={{ padding: 24, fontFamily: "sans-serif" }}>
      <h2>Proctoring Test Page</h2>
      <p>
        Phase:{" "}
        <strong>
          {phase === "pre" ? "Pre-Assessment Capture" : "Exam Proctoring"}
        </strong>
        {" | "}
        <button
          onClick={() => setPhase(phase === "pre" ? "exam" : "pre")}
          style={{
            textDecoration: "underline",
            cursor: "pointer",
            background: "none",
            border: "none",
            color: "#2196f3",
          }}
        >
          Switch to {phase === "pre" ? "Exam" : "Pre-Assessment"}
        </button>
      </p>

      {phase === "pre" && (
        <PreAssessment
          open={phase === "pre"}
          onClose={() => setPhase("exam")}
          {...TEST_IDS}
          onComplete={() => {
            alert("Pre-assessment complete! Switching to exam proctoring.");
            setPhase("exam");
          }}
        />
      )}

      {phase === "exam" && (
        <>
          <div
            style={{
              marginTop: 16,
              padding: 16,
              border: "1px solid #e0e0e0",
              borderRadius: 8,
            }}
          >
            <h3>Exam Content Area</h3>
            <p>
              The webcam overlay is in the bottom-left corner. Snapshots are
              sent every 30 seconds and on tab switch.
            </p>
            <p>Try switching tabs to trigger a visibility-change snapshot.</p>

            {flags.length > 0 && (
              <div
                style={{
                  marginTop: 12,
                  padding: 12,
                  background: "#fff3e0",
                  borderRadius: 4,
                }}
              >
                <strong>Flags ({flags.length}):</strong>
                <ul>
                  {flags.map((f, i) => (
                    <li key={i}>{f}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <ExamProctor
            {...TEST_IDS}
            onFlag={(result) => {
              const msg = result.no_face_detected
                ? `No face detected (score: ${result.similarity_score})`
                : `Face mismatch (score: ${result.similarity_score})`;
              setFlags((prev) => [
                ...prev,
                `${new Date().toLocaleTimeString()} — ${msg}`,
              ]);
            }}
          />
        </>
      )}
    </div>
  );
};

export default ProctorTest;
